import { defineNuxtPlugin, useRuntimeConfig } from '#app'

type Gtag = (...args: unknown[]) => void

type GoogleAnalyticsWindow = Window & {
    dataLayer?: unknown[]
    gtag?: Gtag
}

export default defineNuxtPlugin(() => {
    const { public: publicConfig } = useRuntimeConfig()
    const measurementId = publicConfig.googleAnalyticsId as string
    const gtmId = String(publicConfig.gtmId || '')

    // GTM handles tracking when configured; skip direct gtag.js to avoid duplicate hits
    if (publicConfig.appEnv !== 'production' || !measurementId || /^GTM-[A-Z0-9]+$/.test(gtmId)) {
        return
    }

    const googleWindow = window as GoogleAnalyticsWindow

    googleWindow.dataLayer = googleWindow.dataLayer || []
    googleWindow.gtag = (...args: unknown[]) => {
        googleWindow.dataLayer?.push(args)
    }

    googleWindow.gtag('js', new Date())
    googleWindow.gtag('config', measurementId, { send_page_view: false })

    if (!document.getElementById('google-analytics')) {
        const script = document.createElement('script')

        script.id = 'google-analytics'
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
        document.head.appendChild(script)
    }

    const router = useRouter()

    const trackPageView = (path: string) => {
        googleWindow.gtag?.('event', 'page_view', {
            page_path: path,
            page_location: window.location.href,
            page_title: document.title,
        })
    }

    trackPageView(router.currentRoute.value.fullPath)
    router.afterEach(() => trackPageView(router.currentRoute.value.fullPath))
})
